
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const usePersistStoreData = () => {
 const data= useSelector((state)=> state.StoredData)
const dispatch = useDispatch();
  useEffect(() => {
    data
  }, [dispatch]);


  return data ;
  
};


export default usePersistStoreData;